var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",attrs:{"aria-label":"歪脖鸡皮油"}})
}
var staticRenderFns = []

export { render, staticRenderFns }